var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('j-table',{attrs:{"loading":_vm.loading,"tableColumns":_vm.columns,"tableData":_vm.tableData,"rowKey":record => record.id,"tablePagination":_vm.pagination},on:{"onOrderbyChange":(newOrderby)=>{ _vm.orderby = newOrderby;_vm.fetch(); },"onPaginationChange":(newPagination)=>{ _vm.pagination = newPagination;_vm.fetch(); }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }